import React, { FC, ChangeEvent, useState, useEffect } from 'react';
import { Box, Button, Grid, TextField, Theme, useMediaQuery } from '@mui/material';
import { SupplierListFilter } from 'models/client-directory';
import { useTranslation } from 'react-i18next';
import FilterOnStatusDropdown from 'components/users/shared/filter-on-status-dropdown/filter-on-status-dropdown.component';
import AddIcon from '@mui/icons-material/Add';

type SupplierPageActionsProps = {
    onFilterChange: (supplierListFilter: SupplierListFilter) => void;
    onSupplierDialogOpen: () => void;
    supplierListFilters: SupplierListFilter;
};
const SupplierPageActions: FC<SupplierPageActionsProps> = ({
    onFilterChange,
    onSupplierDialogOpen,
    supplierListFilters,
}: SupplierPageActionsProps) => {
    const { t: translate } = useTranslation(['common', 'client-directory', 'organization']);
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));
    const [supplierListFilter, setSupplierListFilter] = useState<SupplierListFilter>({
        freeText: '',
        active: true,
    });

    useEffect(() => {
        setSupplierListFilter(supplierListFilters);
    }, [supplierListFilters]);

    const handleFilterChange = (filterValue: ChangeEvent<HTMLInputElement>) => {
        setSupplierListFilter({
            freeText: filterValue.target.value,
            active: supplierListFilter.active,
        });
        onFilterChange({
            freeText: filterValue.target.value,
            active: supplierListFilter.active,
        });
    };

    const handleStatusSelected = (active: boolean | null) => {
        setSupplierListFilter({
            freeText: supplierListFilter.freeText,
            active: active,
        });
        onFilterChange({
            freeText: supplierListFilter.freeText,
            active: active,
        });
    };

    return (
        <Box mb={1} display="flex" alignItems="center" flexDirection={!isMobile ? 'row' : 'column-reverse'}>
            <Grid container spacing={1}>
                <Grid item md={4} xs={12}>
                    <TextField
                        id="filter-name"
                        fullWidth
                        onChange={handleFilterChange}
                        value={supplierListFilter.freeText || ''}
                        label={translate('client-directory:SEARCH_SUPPLIER')}
                        placeholder={translate('client-directory:SEARCH_CUSTOMER_PLACEHOLDER')}
                        margin="dense"
                    />
                </Grid>
                <Grid item md={3} xs={12}>
                    <FilterOnStatusDropdown
                        statusSelected={handleStatusSelected}
                        statusValue={supplierListFilter.active}
                        fullWidth
                    />
                </Grid>
            </Grid>
            <Box flex="1 0 auto">
                <Button fullWidth size="medium" onClick={() => onSupplierDialogOpen()} startIcon={<AddIcon />}>
                    {translate('client-directory:ADD_SUPPLIER')}
                </Button>
            </Box>
        </Box>
    );
};

export default SupplierPageActions;
